import { AuthenticationData } from '../store/authentication';
import { KnowYourCustomerRequest, KycAnswer } from '../types/KycTypes';
import { apiClient } from './apiClient';

export const saveKnowYourCustomerAnswers = async (
    apiProxyPath: string,
    apiKey: string,
    authenticationData: AuthenticationData,
    applicationReferenceNumber: string,
    kycAnswers: KycAnswer[],
    kycTemplateVersion?: number,
): Promise<void> => {
    const payload: KnowYourCustomerRequest = {
        kycDetails: {
            kycAnswers,
            templateVersion: kycTemplateVersion,
        },
    };
    await apiClient<void>(`${apiProxyPath}/know_your_customer/${applicationReferenceNumber}/save_survey_answers`, {
        method: 'POST',
        body: payload,
        apiKey,
        authenticationData,
        responseType: 'void',
        sentryTag: 'save_kyc_answers',
        sentryExtra: { arn: applicationReferenceNumber },
    });
};
